import {css} from 'styled-components';

export const baseCheckMarkBulletList = css`
  /* Custom bullet points as check marks */
  ul {
    list-style-type: none;
    padding-left: 0;
  }
  li {
    line-height: 1.6;
    padding-bottom: 8px;
    position: relative;
    padding-left: 1rem;
  }
  ul li:before {
    background-image: url('/images/icons/check.svg');
    background-repeat: no-repeat;
    width: 11px;
    height: 9px;
    content: '';
    margin-left: 0em;
    margin-right: 0.5em;
  }
  li *,
  li:before {
    display: inline-block;
  }
`;

export const checkMarkBulletListAlignTextFeature = css`
  ul li::before {
    position: absolute;
    left: 0;
    top: 0.5rem;
  }
`;